<template>
    <div>
        <v-card>
            <v-card-title>Changes                      
                <v-spacer></v-spacer>
                <div v-if="isAuthorized"> 
                    <v-btn class="primary ma-2" x-small v-on:click="addHowz">Add new change</v-btn>
                </div>
            </v-card-title>
            <span v-if="huov_howz.length === 0">
                <div class="pl-4 pt-3 pb-4">                
                    <v-label><span :class="{'text-color-error': hasError}">{{ this.resulttext }}</span></v-label>
                </div>
            </span>
            <span v-else>
                <howz_table :data="huov_howz" itemtype="change" @updateData="updateData" @executeFunction="executeFunction" class="pb-2 px-2" />
            </span>
        </v-card>
        <addUpdHowz ref="addUpdHowz" :huov_encrid="huov_encrid" @updateData="updateData"/>
        <addUpdHwzr ref="addUpdHwzr" :huov_encrid="huov_encrid" @updateData="updateData"/>      
        <rmHowz ref="rmHowz" @updateData="updateData" @updateField="updateField"/>
        <m_attm ref="m_attm" @updateData="updateData"/>        
    </div>
</template>

<script>
    import mxauthorization from '@/mixins/authorization';
    import howz_table from '@/components/huov/howz/ui/howz_table.vue'
    import addUpdHowz from "@/components/huov/howz/addUpdHowz.vue";
    import addUpdHwzr from "@/components/huov/howz/addUpdHwzr.vue";
    import rmHowz from "@/components/huov/howz/rmHowz.vue";
    import m_attm from "@/components/m_attm.vue";

    export default {
        mounted() {
            this.getAuthorization("acco-changes-update", "isAuthorized");
            this.getHowz();
        },
        props: {
            huov_encrid: String,
        },        
        components: {
            howz_table,
            addUpdHowz,
            addUpdHwzr,
            rmHowz,
            m_attm,
        },
        mixins: [mxauthorization],
        data() {
            return {
                isAuthorized: false,
                descriptionAll: '',
                descriptionOne: '',
                huov_code: '',
                huov_encrids: [],
                huov_howz: [],
                saveState: [],
                resulttext: 'No changes filed',
                hasError: false,  
            }
        },
        methods: {         
            executeFunction(data){
                // this.howz_encrid = data[1].value;
                // console.log(data);
                switch(data[0].value){
                    case 'update_change_all':
                        this.$refs.addUpdHowz.open_dialog("edit_multiple", data[1].value, data[2].value, this.descriptionAll);
                        break;
                    case 'update_change_one':
                        this.$refs.addUpdHowz.open_dialog("edit_single", data[1].value, data[2].value, this.descriptionOne);
                        break;
                    case 'delete_change':
                        this.$refs.rmHowz.open(data[1].value, data[2].value);
                        break;    
                    case 'open_change':     
                        this.$refs.viewHwzr.open(data[1].value, data[2].value);
                        break;
                    case 'add_upd_change_event': 
                        this.$refs.addUpdHwzr.open(data[1].value, data[2].value);
                        break;
                    case 'attachments_change':
                        this.howzAttm(data[2].value);
                        break;                            
                }
            },               
            getHowz(){
                this.$axios.post("ares/json/ares/huov/howz/getHowz.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHowz"
                    },
                    getHowz: {
                        huov_encrid: this.huov_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.resulttext = res.data.error.message;
                        this.hasError = true;
                    } else {   
                        console.log( res.data.getHowz);   
                        let howz = res.data.getHowz;
                        
                        this.huov_howz =howz.howz;   
                        for (let i = 0; i < this.huov_howz.length; i++) {
                            this.huov_howz[i].showChanges = this.saveState[this.huov_howz[i].howz_nr];
                        }
                        this.huov_encrids = howz.huov_encrids;
                        this.hasError = false;
                        this.descriptionAll = howz.descriptionAll;
                        this.descriptionOne = howz.descriptionOne;  
                        this.huov_code = howz.huov_code;  
                    }
                });   
            },               
            addHowz() {
                this.$refs.addUpdHowz.open_dialog("add_single", "", "", "Create new change for " + this.huov_code );
            },            
            updateField(data) {
                this[data.field]=data.value;
            },
            updateData() {
                this.saveState = {};
                for (let i = 0; i < this.huov_howz.length; i++) {
                    this.saveState[this.huov_howz[i].howz_nr] = this.huov_howz[i].showChanges;
                }
                this.getHowz();
                this.$emit('updateData', 'refresh'); // send refresh to parent
            },
            howzAttm(howz_code) {
                this.$refs.m_attm.open('howz', howz_code, '', '', this.howz_encrid, 0);
            }            
        }
    }
</script>

<style scoped>
    .text-color-error {
        color: red;
    }
    .v-label {
        color: '';
    }
</style>